import { useDispatch, useSelector } from "react-redux"
import { key_local_storage_cart, urlapi } from "../../../lib/backend/data"
import { useCallback, useEffect, useState } from "react"
import { toast } from "react-toastify"
import Skeleton from "react-loading-skeleton"
import { cerrarSesion } from "../../../redux/actions/session"
import { Button, ButtonGroup, Col, Row, Spinner, Table } from "react-bootstrap"
import { debounce } from "@mui/material"
import { FaCheckCircle, FaRegClock } from "react-icons/fa"
import { MdUpdateDisabled } from "react-icons/md"
import { GrUpdate } from "react-icons/gr"
import PedidosYaActivar from "./pedidosya"
import UberActivar from "./uber"
import ErrorBoundary from "../../errorsHandler/errorBoundary"
import { url_images } from "../../../lib/global/data"
import { default_proveedores } from "../../proveedores_transporte/data"
import ProveedorDinamico from "./proveedorDinamico"
import Flota from "./flota"
import { calculateTotalCart } from "../../../lib/helpers/main"

const DespachoOrden = (props) => {
    const {
        lat, lng,
        geo_datos,
        selected
    } = props
    const [error, setError] = useState(null)
    const [geofences, setGeofences] = useState([])
    const { viewType, id_orden } = props
    const [campos, setCampos] = useState([])
    const [guardado, setGuardado] = useState(true)
    const user = useSelector(state => state.user)
    const [loadingPicking, setLoadingPicking] = useState(false)
    const [loading, setLoading] = useState(true)
    const [loadingGuardando, setLoadingGuardando] = useState(false)
    const [courriers, setCourriers] = useState([])
    const [loadingMaster, setLoadingMaster] = useState(false)
    const [additionalData, setAdditionalData] = useState({})
    const dispatch = useDispatch()
    const carrito = localStorage.getItem(key_local_storage_cart) ? JSON.parse(localStorage.getItem(key_local_storage_cart)) : []

    const obtenerDatosOrden = async (latitude, longitude) => {
        setError("")
        setLoadingMaster(true)
        return fetch(`${urlapi}/pricing/ecommerce/cobertura`, {
            method: 'POST',
            body: JSON.stringify({ lat: latitude, lng: longitude, total_cart: calculateTotalCart(carrito) }),
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(res => {
                if (res.status === 401) return dispatch(cerrarSesion())
                return res.json()
            })
            .then(res => {
                if (!res) {
                } else if (res.errorMessage) {
                    setError(res.errorMessage)
                } else if (res.message) {
                    setError(res.message)
                } else if (Array.isArray(res.providers)) {
                    setCourriers(res.providers)
                    setGeofences(res.geofences)
                    setAdditionalData(res.additional_data)
                }
                return setLoadingMaster(false)
            })
            .catch(error => {
                return setLoadingMaster(false)
            })
    }

    useEffect(() => {
        setTimeout(() => {
            obtenerDatosOrden(user?.geo_datos?.lat, user?.geo_datos?.lng)
        }, 100);
    }, [user?.direccion, props.key])

    const confirmar = (e) => {
        let logo = ''
        if (e === "uber") {
            logo = `${url_images}/uber.png`
        } else if (e === "pedidosya") {
            logo = `${url_images}/pedidos-ya.png`
        }
        if (!logo) return
        if (props.onConfirm) props.onConfirm({ proveedor_logo: logo })
    }

    const onSelect = (tar) => {
        if (props.onSelect) props.onSelect(tar)
    }

    const mostrarCampos = () => {
        let titulo_boton = loadingPicking ? "GUARDANDO..." : "GUARDAR"
        if (guardado) titulo_boton = "GUARDADO"
        const dinamicos = default_proveedores
        return <div>
            {
                courriers.map((code, i) => {
                    if (!["chilexpress", "bluexpress", "rappi", "uber", "pedidosya", "flota"].includes(code)) return null
                    if (code === "uber") return <div key={i} className="mb-2"><UberActivar code={code} selected={selected} onSelect={(tar) => onSelect(tar)} geo_datos={geo_datos} autoQuote={true} typeView="line" id_orden={id_orden} onConfirm={() => confirmar("uber")} /></div>
                    if (code === "pedidosya") return <div key={i} className="mb-2"><PedidosYaActivar selected={selected} onSelect={(tar) => onSelect(tar)} geo_datos={geo_datos} autoQuote={true} typeView="line" id_orden={id_orden} onConfirm={() => confirmar("pedidosya")} /></div>
                    if (code === "flota") return <div key={i} className="mb-2"><Flota code={code} additionalData={additionalData} geofencesIds={geofences} selected={selected} onSelect={(tar) => onSelect(tar)} geo_datos={geo_datos} autoQuote={true} typeView="line" id_orden={id_orden} onConfirm={() => confirmar("flota")} /></div>

                    const pos = dinamicos.findIndex(co => co.slug === code)
                    const e = pos > -1 ? dinamicos[pos] : { logo: `${url_images}/courriers/truck.jpg` }
                    return <div key={i} className="mb-2">
                        <ProveedorDinamico selected={selected} additionalData={additionalData} onSelect={(tar) => onSelect(tar)} geo_datos={geo_datos} code={code} logo={e.logo} typeView="line" id_orden={id_orden} onConfirm={() => confirmar(code)} />
                    </div>
                })
            }
        </div>
    }

    if (loadingMaster) return <Skeleton count={5} height={40} />

    return <div>
        <ErrorBoundary message={error} />
        {mostrarCampos()}
    </div>
}

export default DespachoOrden